import type { ResourcesById, RunbookRunResource, ProjectResource, EnvironmentResource, RunbookResource } from "@octopusdeploy/octopus-server-client";
import { isEqual } from "lodash";
import { useProjectContext } from "~/areas/projects/context";
import Task from "~/areas/tasks/components/Task/Task";
import { repository } from "~/clientInstance";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import { useErrors } from "~/components/ErrorContext/ErrorContext";
import { PageContent } from "~/components/PageContent/PageContent";
import { useRunbookContext } from "./RunbookContext";
interface RunbookRunPageInternalState extends DataBaseComponentState {
    runbookRun?: RunbookRunResource;
    environmentsById?: ResourcesById<EnvironmentResource>;
}
interface RunbookRunPageInternalProps extends RunbookRunPageProps {
    runbook: RunbookResource;
    project: ProjectResource;
}
class RunbookRunPageInternal extends DataBaseComponent<RunbookRunPageInternalProps, RunbookRunPageInternalState> {
    constructor(props: RunbookRunPageInternalProps) {
        super(props);
        this.state = {};
    }
    async componentDidMount() {
        await this.reload();
    }
    async componentDidUpdate(prevProps: RunbookRunPageInternalProps) {
        const nextRunbook = this.props.runbook;
        const currentRunbook = prevProps.runbook;
        if (!isEqual(currentRunbook, nextRunbook)) {
            await this.reload();
        }
    }
    async reload() {
        await this.doBusyTask(async () => {
            const runbookRun = await repository.RunbookRuns.get(this.props.runbookRunId);
            this.setState({ runbookRun });
        });
    }
    render() {
        const runbookRun = this.state.runbookRun;
        if (runbookRun) {
            return <Task taskId={runbookRun.TaskId} delayRender={() => false} projectId={this.props.project.Id} environmentId={runbookRun.EnvironmentId} tenantId={runbookRun.TenantId ?? undefined}/>;
        }
        return <RunbookRunDetailsWaitingForData busy={this.state.busy}/>;
    }
    static displayName = "RunbookRunPageInternal";
}
interface RunbookRunDetailsWaitingForDataProps {
    busy: Promise<void> | undefined | boolean;
}
function RunbookRunDetailsWaitingForData({ busy }: RunbookRunDetailsWaitingForDataProps) {
    const errors = useErrors();
    return (<PageContent header={{ title: "Task" }} busy={busy} errors={errors}>
            {null}
        </PageContent>);
}
interface RunbookRunPageProps {
    runbookRunId: string;
}
export function RunbookRunPage(props: RunbookRunPageProps) {
    const runbookContext = useRunbookContext();
    const projectContext = useProjectContext();
    const project = projectContext.state.model;
    const runbook = runbookContext.state.runbook;
    if (!project || !runbook) {
        return <RunbookRunDetailsWaitingForData busy={true}/>;
    }
    return <RunbookRunPageInternal project={project} runbook={runbook} {...props}/>;
}
